export const AmazonTemplates = {
  upsertScalingPolicyModal: require('amazon/serverGroup/details/scalingPolicy/upsert/upsertScalingPolicy.modal.html'),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/amazon/src/templates.ts